import React from 'react';
import { getStyle, styleMerge } from '../../utils/utils';
import CBCheckbox from './form_components/CBCheckbox';
import CBMediaQuery from './CBMediaQuery';

class CBLabelAndCheckbox extends React.Component {
  render() {
    const {
      additionalStyles,
      labelText,
      checked,
      onChange,
      color = 'white',
      disabled = false,
    } = this.props;
    let textColor = 'white';
    if (color === 'blue') {
      textColor = 'black';
    }
    return (
      <CBMediaQuery>
        {screenSize => (
          <div
            onClick={disabled ? undefined : onChange}
            style={styleMerge(
              getStyle(screenSize, styles, 'checkboxContainer'),
              additionalStyles || {},
              disabled ? styles.disabled : {},
            )}
          >
            <CBCheckbox checked={checked} color={color} disabled={disabled} />
            {
              !!labelText && (
                <p
                  style={{
                    ...getStyle(screenSize, styles, 'checkboxLabel'),
                    color: textColor,
                    fontFamily: color === 'blue' ? 'TitilliumWeb-Bold' : null,
                    opacity: disabled ? 0.5 : 1,
                  }}
                >
                  {labelText}
                </p>
              )
            }
          </div>
        )}
      </CBMediaQuery>
    );
  }
}

const styles = {
  default: {
    checkboxContainer: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      cursor: 'pointer',
    },
    checkboxLabel: {
      marginLeft: 8,
      marginBottom: 0,
      display: 'flex',
      alignItems: 'center',
    },
    disabled: {
      cursor: 'not-allowed',
      opacity: 0.5,
    },
  },
};

export default CBLabelAndCheckbox;
